import { LayersOffIcon } from './LayersOffIcon';

/**
 * author: Google
 * id 1ADB303D-B8D9-49EF-8EB0-C02AFD269F02
 * name layers-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/layers-off.svg
 * tags
 * - Geographic Information System 
 */
export const LayersClearIcon = LayersOffIcon;
export default LayersClearIcon